var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6471_1942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833252 6.66634H19.1666M6.66658 13.333H13.3333M6.66658 6.66634V19.1663M13.3333 6.66634V19.1663M7.49992 19.1663H12.4999C14.8335 19.1663 16.0002 19.1663 16.8915 18.7122C17.6756 18.3127 18.313 17.6753 18.7124 16.8913C19.1666 16 19.1666 14.8332 19.1666 12.4997V7.49967C19.1666 5.16612 19.1666 3.99935 18.7124 3.10805C18.313 2.32404 17.6756 1.68662 16.8915 1.28715C16.0002 0.833008 14.8335 0.833008 12.4999 0.833008H7.49992C5.16637 0.833008 3.99959 0.833008 3.10829 1.28715C2.32428 1.68662 1.68686 2.32404 1.28739 3.10805C0.833252 3.99935 0.833252 5.16612 0.833252 7.49967V12.4997C0.833252 14.8332 0.833252 16 1.28739 16.8913C1.68686 17.6753 2.32428 18.3127 3.10829 18.7122C3.99959 19.1663 5.16637 19.1663 7.49992 19.1663Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6471_1942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.489108b73ca435b5abfe73c02bb44245.svg";
export { ForwardRef as ReactComponent };